<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class=" col px-0">
            <div class="row">
              <h1 class="text-white">Rayray W</h1>
            </div>
            <div class="row">
              <h2 class="text-white" style="text-indent: 50px">
                The most naughty, cute and sweet bunny.
              </h2>
            </div>
            <div class="row">
              <h4 class="text-white" style="text-indent: 50px">
                His birthday is {{ birthdayStr}}. He is now <b>{{ ageStr }}</b>.
              </h4>
            </div>
            <div class="row pt-4">
              <h4 class="text-white" style="text-indent: 50px">
                Follow our RED (小红书) to see more!
              </h4>
            </div>
            <div class="row pt-3">
              <div class="col-lg-2"></div>
              <div class="col-lg-2">
                <img src="img/rayray/littleredbook.png" class="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg" id="rayray-with-us">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-lg-8 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-favourite-28" size="lg" type="primary" shadow rounded></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3">Rayray with us</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-12 order-md-1">
            <div class="row row-grid">
              <div class="col-lg-3">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/onthigh.jpg" class="img-fluid" />
                </card>
              </div>
              <div class="col-lg-5">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/family.jpg" class="img-fluid" />
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/onback.jpg" class="img-fluid" />
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-secondary" id="rayray-videos">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-collection" size="lg" type="primary" shadow rounded></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3">Rayray Videos</h4>
              </div>
            </div>
          </div>
          <div class="col-lg-6 order-lg-2">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="fallingOptions"></video-player>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-4">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="drinkingOptions"></video-player>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="eatingOptions"></video-player>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playingOptions"></video-player>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg" id="rayray-sleeping">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-lg-8 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-chat-round" size="lg" type="primary" shadow rounded></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3">Rayray Sleeping</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/heart.jpg" class="img-fluid" />
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/lying.jpg" class="img-fluid" />
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <h4 class="text-primary text-uppercase"></h4>
                  <img src="img/rayray/sleeping.jpg" class="img-fluid" />
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-secondary" id="rayray-standing">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-3 order-md-1">
            <icon name="ni ni-bell-55" size="lg" type="primary" shadow rounded></icon>
            <h4 class="display-3">Rayray Standing</h4>
            <div class="pr-md-5">
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3" icon="ni ni-bold-right"></badge>
                    <h6 class="mb-0">He has his last name <b>W</b> on his head!</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3" icon="ni ni-bold-right"></badge>
                    <h6 class="mb-0">He is so tall!</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3 order-md-2">
            <img src="img/rayray/w.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-2">
            <img src="img/rayray/standing.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-2">
            <img src="img/rayray/standing-2.jpg" class="img-fluid floating" />
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg" id="sick-rayray">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-4 order-md-1">
            <icon name="ni ni-ambulance" size="lg" type="primary" shadow rounded></icon>
            <h4 class="display-3">Sick Rayray</h4>
            <div class="pr-md-5">
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3" icon="ni ni-bold-right"></badge>
                    <h6 class="mb-0">Sick Rayray.</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3" icon="ni ni-bold-right"></badge>
                    <h6 class="mb-0">We were super worried.</h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <badge type="primary" circle class="mr-3" icon="ni ni-bold-right"></badge>
                    <h6 class="mb-0">He is worth at least $3000 now.</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-5 order-md-2">
            <img src="img/rayray/medicine.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-2">
            <img src="img/rayray/sick.jpg" class="img-fluid floating" />
          </div>
        </div>
      </div>
    </section>
    <section class="section section-secondary" id="rayray-worth">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-lg-8 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-collection" size="lg" type="primary" shadow rounded></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3">Rayray's Worth</h4>
                <h5>Rayray is priceless.</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-12 order-md-1">
            <table class="table">
              <thead>
                <tr>
                  <th style="word-wrap:break-word;word-break:break-all;width:20%;">Event</th>
                  <th style="word-wrap:break-word;word-break:break-all;width:15%;">Date</th>
                  <th style="word-wrap:break-word;word-break:break-all;width:12%;text-align:right">Cost(USD)</th>
                  <th style="word-wrap:break-word;word-break:break-all;">Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in eventAndCosts" :key="item.id">
                  <td style="word-wrap:break-word;word-break:break-all;width:20%;">{{ item.event }}</td>
                  <td style="word-wrap:break-word;word-break:break-all;width:15%;">{{ item.date }}</td>
                  <td style="word-wrap:break-word;word-break:break-all;width:12%;text-align:right">{{ item.cost }}</td>
                  <td style="word-wrap:break-word;word-break:break-all;" v-html="item.note"></td>
                </tr>
                <tr>
                  <td style="word-wrap:break-word;word-break:break-all;width:20%;"><b>Total</b></td>
                  <td style="word-wrap:break-word;word-break:break-all;width:15%;"></td>
                  <td style="word-wrap:break-word;word-break:break-all;width:12%;text-align:right"><b>${{ totalCost }}</b></td>
                  <td style="word-wrap:break-word;word-break:break-all;"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import {
    videoPlayer
} from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

export default {
  name: "rayray",
  components: {
    Modal,
    videoPlayer
  },
  data() {
    return {
      modal: false,
      defaultPlayerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // play speed
        autoplay: true, // play when your browser is ready
        muted: true, // whether to mute by default
        loop: true, // restart when it ends
        preload: 'auto', // whether to download when parsing <video>
        language: 'zh-CN',
        aspectRatio: '16:9', // proportion
        fluid: true, // suit container in proportion
        sources: [{
          type: "video/mp4", // see github for more types
          src: this.video_src // url of the video
        }],
        poster: this.poster_src, // cover of the video
        // width: document.documentElement.clientWidth, // width of the player
        notSupportedMessage: 'Something went wrong', // default message when the video cannot be played
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      },
    };
  },
  computed: {
      totalCost() {
        var sum = 0;
        for (let i = 0; i < this.eventAndCosts.length; i++) {
          sum += this.eventAndCosts[i].cost;
        }
        return sum;
      },
      birthday() {
        // Month starting from 0, it is 2023/07/24.
        return new Date(2023, 6, 24, 0, 0, 0, 0);
      },
      birthdayStr() {
        return `${this.birthday.getFullYear()}/${this.birthday.getMonth()}/${this.birthday.getDate()}`
      },
      ageStr() {
        let today = new Date();
        let years = today.getFullYear() - this.birthday.getFullYear();
        let months = today.getMonth() - this.birthday.getMonth();
        if (today.getMonth() < this.birthday.getMonth()) {
          // If so, need to fix years and months
          years -= 1;
          months += 12;
        }
        return `${years} years, ${months} months`
      },
      fallingOptions() {
        return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/rayray/falling.mp4"}], aspectRatio: '16:9'}};
      },
      drinkingOptions() {
        return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/rayray/drinking.mp4"}], aspectRatio: '9:16'}};
      },
      eatingOptions() {
        return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/rayray/eating.mp4"}], aspectRatio: '9:16'}};
      },
      playingOptions() {
        return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/rayray/playing.mp4"}], aspectRatio: '9:16'}};
      },
      eventAndCosts() {
        let today = new Date();
        // Car Insurance
        let monthsSinceAccident; {
          // Month/Day starting from 0, it is 2024/09/09.
          let accidentDate = new Date(2024, 8, 8, 0, 0, 0, 0);
          monthsSinceAccident = (today.getFullYear() - accidentDate.getFullYear()) * 12 - accidentDate.getMonth() + today.getMonth();
        }
        // Food
        let daysSinceAdoption; {
          // Month/Day starting from 0, it is 2023/09/23.
          let adoptionDate = new Date(2023, 8, 23, 0, 0, 0, 0);
          daysSinceAdoption = Math.round((today - adoptionDate) / (1000 * 60 * 60 * 24));
        }
        return [
          { event: "Adoption", date: "2023/09/23", cost: 300, note: "" },
          { event: "Daily Necessities", date: "2023/09/23", cost: 150 + 120 + 60 + 30 + 50 + 50*3, note: "Playpen($150), Cage($120), Food Feeder($60), Water Feeder($30), Litter Box($50), Camera($50x3)" },
          { event: "Move to Seattle", date: "2024/05/18", cost: 300, note: "Flight in cabin, Carrier, Playpen, Water/Food Feeder, ..."},
          { event: "Hypovolemia & Dehydration", date: "2024/08/06", cost: 1000, note: "One liver enzyme, ALT was significantly elevated in the 700's (our range goes up to 80). As discussed, this could be due to infection, toxin, trauma, inflammation, liver lobe torsion, or other." },
          { event: "Examination & vaccination", date: "2024/09/04", cost: 500, note: "RHDV-2 Vaccination Medgene. First dose on 2024/09/04 and second dose on 2024/09/25." },
          { event: "Car Insurance", date: "2024/09/10", cost: 100 * monthsSinceAccident, note: `An accident happened when sending Rayray to boarding home. Longgoolu has to pay <b>$100</b> more for insurance due to this. <br>It has been <u><b>${monthsSinceAccident}</b></u> months.` },
          { event: "Boarding", date: "2024/09/10", cost: 750, note: "Rayray boarding for 5 weeks from 2024/09/10 - 2024/10/16. <br/>Location: <a href='http://www.rescuerabbitsrock.com' target='_blank'>Lisa Redmond</a>." },
          { event: "Move back to NJ", date: "2024/10/16", cost: 180, note: "Flight in cabin($100), Carrier($50), playpen($30)."},
          { event: "Destroyed Cables", date: "T.B.Cont.", cost: 50*1 + 20*3, note: "Magsafe($50 x 1), Type-C($20 x 3)."},
          { event: "Timothy Hay", date: `${daysSinceAdoption} days`, cost: 18*Math.round(daysSinceAdoption/14), note: "$18 every two weeks."},
          { event: "Chew Stick", date: `${daysSinceAdoption} days`, cost: 9*Math.round(daysSinceAdoption/14), note: "$9 every two weeks."},
        ];
      }
  }
};
</script>
